export default function truncarString(str: string, maxLength: number = 20) {
    if (str.length <= maxLength) {
        return str;
    } else {
        return str.substring(0, maxLength) + "...";
    }
}